export enum LoginStep {
  CREDENTIALS = 'credentials',
  TOTP = 'totp',
  OTP = 'otp',
}

export interface ILoginFormParams {
  email?: string;
  password?: string;
  totp?: string;
  otp?: string;
  captchaV2?: string;
  y_captcha_response?: string;
}
